export default "__VITE_ASSET__Bn6h2jaX__"